import script from "./HalfGames.vue?vue&type=script&setup=true&lang=js"
export * from "./HalfGames.vue?vue&type=script&setup=true&lang=js"

import "./HalfGames.vue?vue&type=style&index=0&id=301cac22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301cac22"]])

export default __exports__